function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M255.6,127.8c55.9,0.1,103.9,39.6,114.8,94.3l6.4,31.9l32.6,2.3c35,2.4,61.5,32.7,59.1,67.7c-2.3,33.5-30.2,59.4-63.7,59.2 H127.8c-47,0-85.2-38-85.2-85.1c0-43.4,32.6-79.9,75.8-84.7l22.8-2.3l10.6-20.2C171.8,152.2,211.9,127.7,255.6,127.8 M255.6,85.2 c-59.6,0-114.2,33.2-141.6,86C43.8,178.9-6.9,241.9,0.8,312c7,64.8,61.8,114,127,113.9h276.9c58.8,0,106.5-47.7,106.5-106.5 c0-56.2-43.7-101.8-99-105.6C397.4,139.1,331.8,85.2,255.6,85.2z"
}));

var SvgCloud24Px = function SvgCloud24Px(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.1 511.1",
    style: {
      enableBackground: "new 0 0 511.1 511.1"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCloud24Px, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cloud_24px.e1f7c7fe.svg";
export { ForwardRef as ReactComponent };